export const ISSUED_ITEMS_ACTIVITY_CONTAINER_TAG_NAME = 'issued-items-activity-container';
